import React from "react";
import styles from "./Backdrop.module.scss";

const Backdrop = () => <div className={styles.container}></div>;

export default Backdrop;
